import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-22",
  "use": "icon-icon-nav-22-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-22\"><path d=\"M814.208 192l-5.696 1.088-189.824 73.6L405.312 192 204.8 259.584a17.92 17.92 0 0 0-12.8 17.024v537.6c0 9.984 7.808 17.792 17.792 17.792l5.696-1.088 189.824-73.6L618.688 832l200.512-67.584a17.92 17.92 0 0 0 12.8-17.024v-537.6A17.6 17.6 0 0 0 814.208 192z m-195.52 568.896l-213.376-75.008V263.04l213.376 75.008v422.784z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-22.svg
// module id = odlN
// module chunks = 3